const countryCode = [
    {label: "+44", val: "+44", key: "44"},
    {label: "+880", val: "+880", key: "880"},
]

export default countryCode